import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { getUser } from '../services/auth';
import Icon from '../components/Icon';
import './Ranking.css';

const FILTROS = [
  { key: 'geral', label: 'Geral' },
  { key: 'mes', label: 'Mês' },
  { key: 'semana', label: 'Semana' },
  { key: 'hoje', label: 'Hoje' },
];

export default function Ranking() {
  const user = getUser();
  const [filtro, setFiltro] = useState('geral');
  const [ranking, setRanking] = useState([]);
  const [minhaPos, setMinhaPos] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setMinhaPos(null);
    Promise.all([
      api.get(`/ranking?filtro=${filtro}`),
      filtro === 'geral' ? api.get('/ranking/minha-posicao') : Promise.resolve(null),
    ]).then(([rows, pos]) => {
      setRanking(rows);
      if (pos) setMinhaPos(pos.posicao);
    }).catch(() => {}).finally(() => setLoading(false));
  }, [filtro]);

  const usuarioNoTop = ranking.some(r => r.id === user?.id);
  const podio = ranking.length >= 3 ? [ranking[1], ranking[0], ranking[2]] : null;
  const resto = podio ? ranking.slice(3) : ranking;

  function Avatar({ nome, tamanho }) {
    return (
      <div className={`rank-avatar rank-avatar--${tamanho}`}>
        <span className="rank-avatar-placeholder">{nome?.[0]}</span>
      </div>
    );
  }

  return (
    <div>
      <h1 className="page-title">Classificação Top 20</h1>
      <div className="filtro-tabs">
        {FILTROS.map(f => (
          <button key={f.key} className={`filtro-tab${filtro === f.key ? ' active' : ''}`} onClick={() => setFiltro(f.key)}>
            {f.label}
          </button>
        ))}
      </div>
      {loading ? <div className="loading"><div className="spinner" /></div> : (
        <>
          {podio && (
            <div className="podio">
              {podio.map(r => (
                <div key={r.id} className={`podio-col podio-col--${r.posicao}`}>
                  {r.posicao === 1 && <Icon name="medal" size={18} className="podio-coroa" />}
                  <Avatar nome={r.nome} tamanho={r.posicao === 1 ? 'lg' : 'md'} />
                  <b>{r.nome.split(' ')[0]}</b>
                  <small>{r.pontuacao} pts</small>
                  <span className={`podio-base podio-base--${r.posicao}`}>{r.posicao}º</span>
                </div>
              ))}
            </div>
          )}

          <div className="ranking-list">
            {resto.map(r => (
              <div key={r.id} className={`ranking-item${r.id === user?.id ? ' meu' : ''}`}>
                <span className="rank-pos">#{r.posicao}</span>
                <Avatar nome={r.nome} tamanho="sm" />
                <div className="rank-info">
                  <span className="rank-nome">{r.nome}</span>
                  <span className="rank-cidade">{r.cidade_nome}</span>
                </div>
                <span className="rank-pts">{r.pontuacao} pts</span>
              </div>
            ))}
            {ranking.length === 0 && <p className="empty-msg">Nenhum resultado encontrado.</p>}
          </div>

          {filtro === 'geral' && !usuarioNoTop && minhaPos && (
            <div className="minha-posicao-box">
              <div className="minha-posicao-sep">— Sua posição —</div>
              <div className="ranking-item meu minha-posicao-item">
                <span className="rank-pos">#{minhaPos}</span>
                <Avatar nome={user?.nome} tamanho="sm" />
                <div className="rank-info">
                  <span className="rank-nome">{user?.nome} (você)</span>
                </div>
                <span className="rank-pts">{user?.pontos || 0} pts</span>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
